var map = {
	"./beijing.json": "23d5",
	"./china.json": "4d6b",
	"./chongqing.json": "5daf",
	"./fujian.json": "e15c",
	"./gansu.json": "4087",
	"./guangdong.json": "a100",
	"./guangxi.json": "2705",
	"./gui-config.json": "17e1",
	"./guizhou.json": "778a",
	"./hainan.json": "c84b",
	"./hebei.json": "0096",
	"./heilongjiang.json": "9891",
	"./henan.json": "b0cd",
	"./hongkong.json": "9b71",
	"./hubei.json": "ca25",
	"./hunan.json": "d7cf",
	"./jiangsu.json": "c345",
	"./jiangxi.json": "f898",
	"./jilin.json": "1944",
	"./liaoning.json": "9a45",
	"./macau.json": "5556",
	"./neimenggu.json": "b0e2",
	"./ningxia.json": "fa29",
	"./qinghai.json": "1ebe",
	"./shan1xi.json": "c142",
	"./shan3xi.json": "61f3",
	"./shandong.json": "47ef",
	"./shanghai.json": "3434",
	"./sichuan.json": "1228",
	"./taiwan.json": "767f",
	"./tianjin.json": "0a0d",
	"./xinjiang.json": "4ea8",
	"./xizang.json": "b960",
	"./yunnan.json": "0f38",
	"./zhejiang.json": "2c7a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5bd4";